module.exports = __webpack_public_path__ + "static/media/COCA-COLA.14126aaf.jpg";